import {
  getOneDetails,
  getTwoDetails,
  getThreeDetails,
  getFourDetails,
  getDesignSpaceList,
  getProductCategoryList,
  getComplaintInfoUcenter,
  addEvaluate,
  getComplaintInfo
} from '@/api/customerCenter'

const state = {
  labels: ''
}

const mutations = {
  SET_LABELS(state, labels) {
    state.labels = labels
  }
}

const actions = {

  // R01-获取01平面规划方案详情
  getOneDetails({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getOneDetails(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // R02-获取02功能设计方案详情
  getTwoDetails({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getTwoDetails(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // R03-获取效果搭配方案详情
  getThreeDetails({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getThreeDetails(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // R04-获取产品设计方案详情
  getFourDetails({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getFourDetails(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // R11-获取设计订单空间列表
  getDesignSpaceList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getDesignSpaceList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // R08-获取产品配置方案分类列表
  getProductCategoryList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getProductCategoryList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // A-22-客诉详情（小程序）
  getComplaintInfoUcenter({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getComplaintInfoUcenter(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // F-03-问题处理评价
  addEvaluate({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      addEvaluate(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // F-07-问题处理详情
  getComplaintInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getComplaintInfo(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
